export const release = '378f0d1ae0d44b649f732672f77cfd317246ac38';
